// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".between[data-v-d04d3c6e] {\n  display: flex;\n}\n.betweenInput[data-v-d04d3c6e] {\n  width: 150px;\n  margin-right: 10px;\n}\n.betweenBox[data-v-d04d3c6e] {\n  margin-right: 10px;\n}\n.red[data-v-d04d3c6e] {\n  color: #f56c6c;\n  margin-right: 4px;\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
